import { HttpClient, HttpHeaders } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ZzzConfigService } from "src/app/zzz/core/config/config.service";
import { ReponseActionApiBase } from "src/app/zzz/core/shared/core.models";

export class CommentairePlansOfficielsDto {
  commentaire: string;
  geometrieX: string;
  geometrieY: string;
  noRegionAdmin: string;
  consultationPubliqueId: number;
  typePlan: string;
  captcha: string;
  nom: string;
  prenom: string;
  courriel: string;
}

export interface ReponseCommentairePlansOfficiels extends ReponseActionApiBase {
  commentairePlanOfficiel: CommentairePlansOfficielsDto
}

@Injectable({
  providedIn: 'root'
})
export class InscrireCommentaireService {
  #httpClient = inject(HttpClient);
  #configService = inject(ZzzConfigService);

  readonly #urlApi = this.#configService.get().authApiEndPoint;

  creerCommentairePlanOfficiel(commentairePlanOff: CommentairePlansOfficielsDto): Promise<ReponseCommentairePlansOfficiels> {
    var headers = new HttpHeaders();
    headers = headers.append('ZZZ-Captcha-Code', commentairePlanOff.captcha);
    headers = headers.append('interceptError', 'false');

    return this.#httpClient.post<ReponseCommentairePlansOfficiels>(`${this.#urlApi}/sigtapi/commentaires-plan-officiel`, commentairePlanOff, { headers, withCredentials: true }).toPromise();
  }

  imagecaptcha(): Observable<Blob> {
    return this.#httpClient.get(`${this.#urlApi}/zzz-captcha`, { responseType: 'blob' });
  }

  public supprimerCommentaire(id: number) {
    const url = `${this.#urlApi}/sigtapi/commentaires-plan-officiel/?commentairePlanOfficielId=${id}`;
    return this.#httpClient.delete<ReponseCommentairePlansOfficiels>(
      url
    );
  }
}
